import type {
  TrackingEvent,
  InteractionTrackingEvent,
} from '@xing-com/crate-communication-tracking';
import { useTracking } from '@xing-com/crate-communication-tracking';

export type TrackingType = {
  PropTrackAction?: string;
  PropActionOrigin?: string;
  EventVideoFinished?: number;
  EventVideoStarted?: number;
  PropItemID?: string;
  PropChannel?: string;
  pageName?: string;
};

export type PageView = {
  channel?: string;
  page: string;
  PropContextDimension1?: string;
  PropTrackAction?: string;
};

export type XingTrackType =
  | TrackingEvent<PageView>
  | InteractionTrackingEvent<TrackingType>;

export type UsePageView = {
  track: XingTrackType;
  page: string;
};

export function useTrackVideoStart(): () => void {
  const { track } = useTracking<XingTrackType>();

  return () => {
    track({
      type: 'interaction',
      event: 'EventVideoStarted',
      EventVideoStarted: 1,
      PropItemID: 'bewerbung_topic_page_video',
      PropActionOrigin: 'career_hub_application_home_and_tricks',
    });
  };
}

export function useTrackVideoEnd(): () => void {
  const { track } = useTracking<XingTrackType>();

  return () => {
    track({
      type: 'interaction',
      event: 'EventVideoFinished',
      EventVideoFinished: 1,
      PropItemID: 'bewerbung_topic_page_video',
      PropActionOrigin: 'career_hub_application_home_and_tricks',
    });
  };
}

export function useTrackInsightsClick(): () => void {
  const { track } = useTracking<XingTrackType>();

  return () => {
    track({
      type: 'interaction',
      event: 'PropTrackAction',
      PropTrackAction: 'career_hub_application_home_insights_click',
    });
  };
}
